

class AuthRepository {
    pinLogin = (merchantAdminId, pin) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/merchant/api/merchant_admin/${merchantAdminId}/pin_login`,
                type: "POST",
                data: {
                    pin: pin,
                },
                success: response => {
                    resolve(response)
                }
            })
            .fail(xhr => {
                let json  = xhr.responseJSON
                let message = "Fail to login"
                if (json && json.message) {
                    message = json.message
                }
                reject(message)
            })
        })
    }
}

export default new AuthRepository